import React from 'react';

export const MultiversX = () => (
  <svg
    width='20'
    height='16'
    viewBox='0 0 20 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M11.0078 8L19.375 3.32661L17.9683 0.5L10.3066 3.73976C10.1093 3.8233 9.89064 3.8233 9.69336 3.73976L2.03168 0.5L0.625 3.32661L8.99218 8L0.625 12.6734L2.03168 15.5L9.69336 12.2602C9.89064 12.1767 10.1093 12.1767 10.3066 12.2602L17.9683 15.5L19.375 12.6734L11.0078 8Z'
      fill='#23F7DD'
    />
  </svg>
);
